<template>
	<div>
		<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
			<router-link :to="{path: '/tasks-types'}" class="btn btn-link">
				<font-awesome-icon :icon="['fas', 'chevron-left']"></font-awesome-icon>
			</router-link>
			<h1 class="h2">Изменение типа задач</h1>
			<div class="btn-toolbar mb-2 mb-md-0">
				<button type="button" class="btn btn-primary mr-2" @click="onSave()">
					<font-awesome-icon :icon="['fas', 'save']"></font-awesome-icon>
				</button>
				<button type="button" class="btn btn-danger" @click="onDelete()">
					<font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
				</button>
				<!--
				<div class="btn-group me-2">
					<button type="button" class="btn btn-sm btn-outline-secondary">Share</button>
					<button type="button" class="btn btn-sm btn-outline-secondary">Export</button>
				</div>
				<button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle">
					<span data-feather="calendar"></span>
					This week
				</button>
				-->
			</div>
		</div>
		<b-overlay :show="overlay" rounded="lg" variant="white">
			<div class="row">
				<div class="col-md-6 offset-md-3">
					<div id="input-group-id" role="group" class="form-group">
						<label id="input-group-id" for="input-id" class="d-block">ID типа задач:</label>
						<div>
							<input id="input-id" type="number" class="form-control" v-model="id" readonly />
						</div>
					</div>
					<div id="input-group-pos" role="group" class="form-group">
						<label id="input-group-pos" for="input-pos" class="d-block">Позиция типа задач:</label>
						<div>
							<input id="input-pos" type="number" class="form-control" v-model="pos" />
						</div>
					</div>
					<div id="input-group-name" role="group" class="form-group">
						<label id="input-group-name" for="input-name" class="d-block">Название типа задач:</label>
						<div>
							<input id="input-name" type="text" placeholder="Например: Проект" class="form-control" v-model="name" autofocus />
						</div>
					</div>
					<div id="input-group-is-default" role="group" class="form-group">
						<label id="input-group-is-default" for="checkbox-is-default" class="d-block">Тип задач по умолчанию:</label>
						<div>
							<input type="checkbox" id="checkbox-is-default" class="form-control" v-model="is_default" />
						</div>
					</div>
					<div id="input-group-default-title" role="group" class="form-group">
						<label id="input-group-default-title" for="input-default-title" class="d-block">Заголовок задач по умолчанию:</label>
						<div>
							<input id="input-default-title" type="text" class="form-control" v-model="default_title" />
						</div>
					</div>
					<div id="input-group-default-description" role="group" class="form-group">
						<label id="input-group-default-description" for="input-default-description" class="d-block">Описание задач по умолчанию:</label>
						<div>
							<textarea id="input-default-description" rows="3" class="form-control" v-model="default_description"></textarea>
						</div>
					</div>
					<div id="input-group-required-user-assigned" role="group" class="form-group">
						<label id="input-group-required-user-assigned" for="checkbox-required-user-assigned" class="d-block">Назначенный пользователь обязателен для заполнения:</label>
						<div>
							<input type="checkbox" id="checkbox-required-user-assigned" class="form-control" v-model="required_user_assigned" />
						</div>
					</div>
					<div id="input-group-required-estimate" role="group" class="form-group">
						<label id="input-group-required-estimate" for="checkbox-required-estimate" class="d-block">Оценка времени обязательна для заполнения:</label>
						<div>
							<input type="checkbox" id="checkbox-required-estimate" class="form-control" v-model="required_estimate" />
						</div>
					</div>
					<div id="input-group-required-date-deadline" role="group" class="form-group">
						<label id="input-group-required-date-deadline" for="checkbox-required-date-deadline" class="d-block">Дата дедлайна обязательна для заполнения:</label>
						<div>
							<input type="checkbox" id="checkbox-required-date-deadline" class="form-control" v-model="required_date_deadline" />
						</div>
					</div>
				</div>
			</div>
			<div class="row mb-4">
				<div class="col-md-6 offset-md-3">
					<div class="mb-2">Статусы типа задач:</div>
					<ul class="list-group">
						<li class="list-group-item" v-for="status in statuses" :key="status.id">
							<div class="row align-items-center">
								<div class="col-1">
									<input type="checkbox" class="form-control" v-model="statuses_id[status.id]" @change="onSaveStatus(status.id)" />
								</div>
								<div class="col-6">{{status.name}}</div>
								<div class="col-5">{{status.status_type_name}}</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6 offset-md-3">
					<div class="mb-2">Дополнительные поля для задач:</div>
					<ul class="list-group">
						<li class="list-group-item" v-for="cf in custom_fields" :key="cf.id">
							<div class="row align-items-center">
								<div class="col-1">
									<input type="checkbox" class="form-control" v-model="custom_fields_id[cf.id]" @change="onSaveCustomField(cf.id)" />
								</div>
								<div class="col-6">{{cf.name}}</div>
								<div class="col-5">{{cf.type}}</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</b-overlay>
		<div class="alert alert-info" v-html="result" v-if="result != ''"></div>
	</div>
</template>

<style lang="css">

</style>

<script>
import { useMeta } from 'vue-meta';
import BOverlay from '@/components/bootstrap/overlay.vue';

export default {
	name: 'TasksTypeEdit',
	setup(){
		useMeta({title: 'Изменение типа задач'});
	},
	data: () => ({
		overlay: false,
		
		id: '',
		pos: 0,
		name: '',
		is_default: 0,
		default_title: '',
		default_description: '',
		required_user_assigned: 0,
		required_estimate: 0,
		required_date_deadline: 0,
		
		statuses_id: {},
		statuses: [],
		types_statuses: [],
		
		custom_fields_id: {},
		custom_fields: [],
		types_custom_fields: [],
		
		result: '',
	}),
	computed: {
		token(){
			return this.$store.state.token;
		},
	},
	methods: {
		async loadData(id){
			await fetch('/api/tasks-types/'+id+'?' + new URLSearchParams({
				virtualspace_id: 1,
			}), {
				headers: {
					Authorization: 'Bearer '+this.token,
				},
			}).then(stream => stream.json()).then(data => {
				this.id = data.id;
				this.pos = data.pos;
				this.name = data.name;
				this.is_default = data.is_default;
				this.default_title = data.default_title;
				this.default_description = data.default_description;
				this.required_user_assigned = data.required_user_assigned;
				this.required_estimate = data.required_estimate;
				this.required_date_deadline = data.required_date_deadline;
			}).catch(error => {
				alert('Ошибка! '+error);
				console.error(error);
			});
		},
		async loadTasksStatuses(){
			await fetch('/api/tasks-statuses?' + new URLSearchParams({
				virtualspace_id: 1,
			}), {
				headers: {
					Authorization: 'Bearer '+this.token,
				},
			}).then(stream => stream.json()).then(data => {
				this.statuses = data.list;
				data.list.forEach((item) => {
					this.statuses_id[item.id] = false;
				});
			}).catch(error => {
				alert('Ошибка! '+error);
				console.error(error);
			});
		},
		async loadTasksTypesStatuses(){
			await fetch('/api/tasks-types-statuses-by-type/'+this.id+'?' + new URLSearchParams({
				virtualspace_id: 1,
			}), {
				headers: {
					Authorization: 'Bearer '+this.token,
				},
			}).then(stream => stream.json()).then(data => {
				this.types_statuses = data.list;
				data.list.forEach((item) => {
					this.statuses_id[item.status_id] = true;
				});
			}).catch(error => {
				alert('Ошибка! '+error);
				console.error(error);
			});
		},
		async loadTasksCustomFields(){
			await fetch('/api/tasks-custom-fields?' + new URLSearchParams({
				virtualspace_id: 1,
			}), {
				headers: {
					Authorization: 'Bearer '+this.token,
				},
			}).then(stream => stream.json()).then(data => {
				this.custom_fields = data.list;
				data.list.forEach((item) => {
					this.custom_fields_id[item.id] = false;
				});
			}).catch(error => {
				alert('Ошибка! '+error);
				console.error(error);
			});
		},
		async loadTasksTypesCustomFields(){
			await fetch('/api/tasks-types-custom-fields-by-type/'+this.id+'?' + new URLSearchParams({
				virtualspace_id: 1,
			}), {
				headers: {
					Authorization: 'Bearer '+this.token,
				},
			}).then(stream => stream.json()).then(data => {
				this.types_custom_fields = data.list;
				data.list.forEach((item) => {
					this.custom_fields_id[item.custom_field_id] = true;
				});
			}).catch(error => {
				alert('Ошибка! '+error);
				console.error(error);
			});
		},
		onSaveStatus(status_id){
			this.result = 'Сохранение...';
			this.overlay = true;
			
			let formData = new FormData();
			formData.append('virtualspace_id', 1);
			formData.append('type_id', this.id);
			formData.append('status_id', status_id);
			
			fetch('/api/tasks-types-statuses', {
				method: 'POST',
				body: formData,
				headers: {
					Authorization: 'Bearer '+this.token,
				},
			}).then(stream => stream.json()).then(data => {
				if(ret.success) this.result = 'Изменения успешно сохранены';
				else this.result = '';
				this.overlay = false;
			}).catch(error => {
				console.error(error);
				this.overlay = false;
				this.result = 'Ошибка! '+error;
			});
		},
		onSaveCustomField(custom_field_id){
			this.result = 'Сохранение...';
			this.overlay = true;
			
			let formData = new FormData();
			formData.append('virtualspace_id', 1);
			formData.append('type_id', this.id);
			formData.append('custom_field_id', custom_field_id);
			
			fetch('/api/tasks-types-custom-fields', {
				method: 'POST',
				body: formData,
				headers: {
					Authorization: 'Bearer '+this.token,
				},
			}).then(stream => stream.json()).then(data => {
				if(ret.success) this.result = 'Изменения успешно сохранены';
				else this.result = '';
				this.overlay = false;
			}).catch(error => {
				console.error(error);
				this.overlay = false;
				this.result = 'Ошибка! '+error;
			});
		},
		onSave(){
			this.result = 'Сохранение...';
			this.overlay = true;
			
			let formData = new FormData();
			formData.append('virtualspace_id', 1);
			formData.append('pos', this.pos);
			formData.append('name', this.name);
			formData.append('is_default', this.is_default);
			formData.append('default_title', this.default_title);
			formData.append('default_description', this.default_description);
			formData.append('required_user_assigned', this.required_user_assigned);
			formData.append('required_estimate', this.required_estimate);
			formData.append('required_date_deadline', this.required_date_deadline);
			
			fetch('/api/tasks-types/'+this.id, {
				method: 'POST',
				body: formData,
				headers: {
					Authorization: 'Bearer '+this.token,
				},
			}).then(stream => stream.json()).then(ret => {
				if(ret.success) this.result = 'Изменения успешно сохранены';
				else this.result = '';
				this.overlay = false;
			}).catch(error => {
				console.error(error);
				this.overlay = false;
				this.result = 'Ошибка! '+error;
			});
		},
		onDelete(){
			if(confirm('Вы уверены?')){
				this.overlay = true;
				fetch('/api/tasks-types/'+this.id, {
					method: 'DELETE',
					headers: {
						Authorization: 'Bearer '+this.token,
					},
				}).then(stream => stream.json()).then(ret => {
					if(ret.success){
						this.$router.push('/tasks-types');
					} else {
						this.overlay = false;
					}
				}).catch(error => {
					console.error(error);
					this.overlay = false;
					this.result = 'Ошибка! '+error;
				});
			}
		},
	},
	async beforeMount(){
		window.scrollTo(0, 0);
		this.overlay = true;
		await this.loadData(this.$route.params.id);
		await this.loadTasksStatuses();
		await this.loadTasksTypesStatuses();
		await this.loadTasksCustomFields();
		await this.loadTasksTypesCustomFields();
		this.overlay = false;
	},
	async beforeRouteUpdate(to, from, next){
		next();
		window.scrollTo(0, 0);
		this.overlay = true;
		await this.loadData(to.params.id);
		await this.loadTasksStatuses();
		await this.loadTasksTypesStatuses();
		await this.loadTasksCustomFields();
		await this.loadTasksTypesCustomFields();
		this.overlay = false;
	},
	components: {
		BOverlay,
	},
}
</script>